import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { MotionConfig } from "framer-motion";
import { AppRoutes } from "./routes";

function App() {
  return (
    <HelmetProvider>
      {/* UI/UX REFRESH - Every framer-motion animation honours the OS "reduce motion" setting */}
      <MotionConfig reducedMotion="user">
      <div className="App">
        <AppRoutes />
        <Toaster
        position="top-right"
        containerStyle={{
          top: 80,
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
            // UI/UX REFRESH - Softer, rounded, elevated toasts
            borderRadius: "14px",
            padding: "12px 16px",
            fontSize: "14px",
            fontWeight: 500,
            boxShadow:
              "0 18px 40px -12px rgba(28, 25, 23, 0.45), 0 4px 12px -4px rgba(28, 25, 23, 0.25)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: "#10b981",
              secondary: "#fff",
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
      </div>
      </MotionConfig>
    </HelmetProvider>
  );
}

export default App;
